import styled from "styled-components";

export const StyledTechnology = styled.li`

    width: 100%;
    padding: 15px 22px;

    background-color: var(--color-grey-4);

    display: flex;
    justify-content: space-between;
    align-items: center;

    cursor: pointer;

    transition: 0.3s ease;
    :hover{
        background-color: var(--color-grey-2);
    }

    h3{
        color: var(--color-grey-0);
        font-weight: 700;
        font-size: 14.21px;
        line-height: 22px;

        cursor: pointer;
    }

    h3:hover{
        text-decoration: underline;
    }

    span{
        font-weight: 400;
        font-size: 12.182px;
        line-height: 22px;

        color: var(--color-grey-1);
        transition: 0.3s ease;
    }

    :hover span{
        color: var(--color-grey-0);
    }

    div{
        display: flex;
        align-items: center;
        gap: 25px;
    }

    button{
        background-color: transparent;
        border: none;

        opacity: 0.9;
    }

    button:hover{
        opacity: 1;
    }

    button img{
        pointer-events: none;
    }
`